import "./map.scss";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import axios from 'axios';
import { Icon, divIcon, marker, point } from "leaflet";
import { Button } from "antd";
import { useEffect, useState } from "react";

// create custom icon
const customIcon = new Icon({
    iconUrl: require("../../../../src/assets/images/placeholder.png"),
    iconSize: [38, 38]
});

// custom cluster icon
const createClusterCustomIcon = function (cluster) {
    return new divIcon({
        html: `<span class="cluster-icon">${cluster.getChildCount()}</span>`,
        className: "custom-marker-cluster",
        iconSize: point(33, 33, true)
    });
};

const GEOCODING_API_URL = 'https://nominatim.openstreetmap.org/search';

export default function App() {
    const [location, setLocation] = useState('');
    const [markers, setMarkers] = useState([]);
    const initialPosition = [9.8787, 76.3671];
    const [position, setPosition] = useState(initialPosition)
    const [searchResult, setSearchResult] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);

    const handleInputChange = (event) => {
        setLocation(event.target.value);
    };

    async function getCoordinates(locationName) {
        try {
            const response = await axios.get(GEOCODING_API_URL, {
                params: {
                    q: locationName,
                    format: 'json',
                    addressdetails: 1,
                    limit: 5,
                },
            });

            if (response.length > 0) {
                setSearchResult(response);
                const { lat, lon } = response[0];
                return [parseFloat(lat), parseFloat(lon)];
            } else {
                console.error('Location not found');
                return null;
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
            return null;
        }
    }
    let geocode 

    const handleAddLocation = async () => {
        if (location) {
            if (!location[0]?.place_id) {
                geocode = await getCoordinates(location);
            }
            else {
                geocode = await getCoordinates(location[0]?.display_name);
            }
            if (geocode) {
                const [lat, lon] = geocode;
                // setMarkers([...markers, { lat, lon, popUp: `Location: ${location}` }]);
                setPosition([lat, lon]);
            }
        }
    };

    useEffect(() => {
        if (selectedLocation.length > 0) {
            const { lat, lon } = selectedLocation[0];
            let locationData = selectedLocation[0]?.address?.city;
            setMarkers([{ lat, lon, popUp: `Location: ${locationData}` }]);
        }
    }, [selectedLocation]);
    const PanToPosition = () => {
        const map = useMap();

        useEffect(() => {
            if (markers.length > 0) {
                map.flyTo([markers[0].lat, markers[0].lon], map.getZoom());
            }
        }, [markers, map]);

        return null;
    };
    const AddMarkerOnClick = () => {
        useMapEvents({
            click(e) {
                const newMarker = e.latlng;
                console.log('located details', newMarker)
                setMarkers([{ lat: newMarker.lat, lon: newMarker.lng, popUp: `Custom Location` }]);
            },
        });
        return null;
    };

    useEffect(() => {
        console.log('markers', location)
    }, [location])

    return (
        <>
            <div className="search_location_wrap">
                <input
                    type="text"
                    value={location.length > 0 ? location[0]?.display_name : ''}
                    className="input_field"
                    onChange={handleInputChange}
                    placeholder="Enter a location"
                />
                {
                    searchResult.length > 0 && (
                        <ul className="search_result">
                            {searchResult.map((el, index) => (
                                <li key={index} onClick={() => {
                                    let selected = searchResult.filter(obj => obj.display_name === el.display_name);
                                    setSelectedLocation(selected);
                                    setSearchResult([]);
                                    setLocation(selected);
                                }}>
                                    {el.display_name}
                                </li>
                            ))}
                        </ul>
                    )
                }
                <Button onClick={handleAddLocation} type="primary">Search Location</Button>
            </div>
            <MapContainer center={position} zoom={13} style={{ height: '100vh', width: '100%' }}>
                <TileLayer
                    attribution="Google Maps"
                    url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}" // satellite
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
                <AddMarkerOnClick />
                <PanToPosition />
                <MarkerClusterGroup
                    chunkedLoading
                    iconCreateFunction={createClusterCustomIcon}
                >
                    {markers.map((marker, index) => (
                        <Marker key={index} position={[marker.lat, marker.lon]} icon={customIcon}>
                            <Popup>{marker.popUp}</Popup>
                        </Marker>
                    ))}
                </MarkerClusterGroup>
            </MapContainer>
        </>
    );
}
